import {Injectable} from '@angular/core';
import { Router } from '@angular/router';

@Injectable()
export class RecentProjectsService {
 
  constructor(private router: Router) {
    

  }

  getProjects() {
    
  }

  clearProjects() {
   
  }

  redirectTo() {
    this.router.navigate(['/dashboard']);
  }

}



// WEBPACK FOOTER //
// C:/Users/stivens/Lab/sonever/repos/taller-web/src/app/shared/layout/header/recent-projects/recent-projects.service.ts